import React from "react";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <div className="page-enter" data-testid="about-page">
      <section className="max-w-5xl mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="overline">About the Studio</div>
        <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl mt-4" data-testid="about-heading">
          A small crew with a large <em style={{ color: "var(--gl-amber)" }}>shovel</em>.
        </h1>
        <p className="mt-8 text-lg leading-relaxed max-w-2xl" style={{ color: "var(--gl-muted)" }}>
          GraveLight Studio was founded on the idea that the most compelling stories are often
          found just beneath the surface, waiting to be uncovered. We make films, identities,
          title sequences, and live event coverage for clients who prefer atmosphere over noise,
          and craft over convenience. We work deliberately, with care and intention — creating
          stories that outlast the moment.
        </p>
      </section>

      <section
        className="py-20 md:py-28 border-y"
        style={{ borderColor: "var(--gl-border)", background: "var(--gl-surface)" }}
        data-testid="about-values"
      >
        <div className="max-w-5xl mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-2 gap-10">
          <div>
            <div className="overline">Our creed</div>
            <h2 className="font-display text-4xl mt-3">Just keep digging.</h2>
          </div>
          <div className="space-y-6 text-sm" style={{ color: "var(--gl-muted)" }}>
            <p>
              We take on a select number of projects each year, working closely with each one
              from concept to completion.
            </p>
            <p>
              We prefer the word <em>unearthing</em> over "branding" or "making" — it better
              describes what actually happens when a story is working. You don't invent it. You
              find it underneath, and then carefully brush the dirt away.
            </p>
          </div>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-6 md:px-10 py-20" data-testid="about-team">
        <div className="overline">The Crew</div>
        <h2 className="font-display text-4xl mt-3 mb-10">The hands behind the lantern</h2>

        <div className="gl-card p-8 md:p-10" data-testid="team-member-evan">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
            <div className="md:col-span-1">
              <div
                className="relative overflow-hidden mb-5"
                style={{
                  aspectRatio: "4 / 5",
                  border: "1px solid var(--gl-border)",
                  borderRadius: 2,
                }}
                data-testid="evan-portrait"
              >
                <img
                  src="/evan.png"
                  alt="Evan Linen — Founder & Creative Director"
                  className="w-full h-full object-cover"
                  style={{ filter: "saturate(0.9) contrast(1.05)" }}
                />
                <div
                  className="absolute inset-0 pointer-events-none"
                  style={{
                    background:
                      "linear-gradient(to top, rgba(5,6,8,0.55), rgba(5,6,8,0.05) 45%, transparent)",
                  }}
                />
              </div>
              <div className="font-display text-3xl leading-tight">Evan Linen</div>
              <div className="overline mt-2">Founder &amp; Creative Director</div>
            </div>
            <div className="md:col-span-2 space-y-4 text-sm" style={{ color: "var(--gl-muted)" }}>
              <p>
                Evan Linen is a creative director leading GraveLight Studio from concept to
                completion. Working in a space between light and shadow, he defines the vision,
                shapes the cut, and oversees the decisions that guide each project's final form.
              </p>
              <p>
                GraveLight Studio operates as a focused core with a network of trusted
                collaborators — cinematographers, editors, designers, and animators — brought in
                as each project demands.
              </p>
              <p>
                Every project is anchored by a single vision, then expanded through the right
                people at the right time.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-14 text-center">
          <Link to="/contact" className="btn-amber" data-testid="about-cta-contact">Say hello</Link>
        </div>
      </section>
    </div>
  );
}
